module.exports = __webpack_public_path__ + "img/tiktok.2472eff4.svg";